// extracted by mini-css-extract-plugin
export default {"titleWrap":"MypageContentHeader_titleWrap__kJR0t"};